module.exports = __webpack_public_path__ + "static/video-making-h265-da63b677db2d4ff3ddeb60be70495117.mp4";